export { default } from "./card-property"